import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './context/AuthContext';
import { UploadProvider } from './context/UploadContext';
import { AutoUploadProvider } from './context/AutoUploadContext';
import AppRoutes from './routes/AppRoutes';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <UploadProvider>
          <AutoUploadProvider>
            <AppRoutes />
            <ToastContainer position="top-right" autoClose={3000} />
          </AutoUploadProvider>
        </UploadProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
